import { empty, Image } from "@";

const NoDataFound = ({ className }) => {
  return (
    <div
      className={`flex h-full flex-col items-center justify-center gap-2 ${className}`}
    >
      <span className="relative inline-flex items-center justify-center">
        {/* Soft halo */}
        <span
          aria-hidden
          className="absolute inset-0 -z-0 mx-auto h-16 w-16 rounded-full bg-gradient-to-br from-purple-100/60 to-transparent blur-xl dark:from-purple-900/20"
        />
        <div className="relative opacity-40 dark:opacity-25">
          <Image
            click={() => {}}
            className="mx-auto"
            src={empty}
            size={50}
            alt="empty"
          />
        </div>
      </span>
      <h1 className="text-xs font-medium tracking-tight text-gray-400 dark:text-gray-500">
        لا توجد بيانات لعرضها
      </h1>
    </div>
  );
};

export default NoDataFound;
